import React from 'react';

import Button from 'common/Button';

import 'styles/common/confirmation-modal.scss';

// DEPRECATED: use components/dialog/SalonModal.component
const ConfirmationModal = ({
  leftButtonCallback,
  leftButtonText,
  popupMessage,
  popupTitle,
  rightButtonCallback,
  rightButtonText,
}) => (
  <div data-bem="ConfirmationModal--common">
    <div className="overlay" />
    <div className="confirmation-modal animated zoomIn">
      <div className="modal-body">
        <h2 className="modal-title"> {popupTitle}</h2>
        <div className="modal-content">{popupMessage}</div>
        <div className="modal-footer">
          <Button buttonName={leftButtonText} onClickButton={leftButtonCallback} className="btn-violet-link" />
          <Button buttonName={rightButtonText} onClickButton={rightButtonCallback} />
        </div>
      </div>
    </div>
  </div>
);

export default ConfirmationModal;
